import { render, staticRenderFns } from "./ModattaIcon.vue?vue&type=template&id=0242d9cb"
import script from "./ModattaIcon.vue?vue&type=script&lang=js"
export * from "./ModattaIcon.vue?vue&type=script&lang=js"
import style0 from "./ModattaIcon.vue?vue&type=style&index=0&id=0242d9cb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports